export default "__VITE_ASSET__BevEWGh5__"